import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { withRouter } from 'react-router';
import { Experience } from './experience.component';
import { ExperienceActions, selectCurrentExperience } from '../../modules/experience';
import { ContentRegistryActions } from '../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentExperienceBySlug: ExperienceActions.setCurrentExperienceBySlug,
      fetchExperience: ContentRegistryActions.fetchExperience,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Experience);
